import { render } from "./MessageAddPage.vue?vue&type=template&id=7edf9199"
import script from "./MessageAddPage.vue?vue&type=script&lang=js"
export * from "./MessageAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__